function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import React, { useEffect, useState, useContext } from 'react';
import { Row, Col } from 'reactstrap';
import { _translate, WeverCoreContext } from "../../../../services/core";
import { useWorkFlow } from "../../../contexts/workflow";
import Autocomplete from "../../../form/autocomplete";
import Collector from "../../../../services/collector";
var SelectionListLineStops = function SelectionListLineStops(props) {
  var _currentQuestion$publ;
  var onChange = props.onChange,
    index = props.index;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 1),
    responseValue = _useState2[0];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    localResponses = _useState4[0],
    setResponses = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    line = _useState6[0],
    setLine = _useState6[1];
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  var currentOrder = collector.currentOrder,
    responses = collector.responses,
    currentQuestion = collector.currentQuestion;
  var min_character_search = (_currentQuestion$publ = currentQuestion.publicParameters) === null || _currentQuestion$publ === void 0 ? void 0 : _currentQuestion$publ.min_character_search;
  var getCurrentResponseValue = function getCurrentResponseValue() {
    return localResponses ? _objectSpread({}, localResponses) : {};
  };
  var handleChangeLine = function handleChangeLine(optionsToValue, options) {
    var _geojson$geometry;
    setLine(options.value.id);
    var geojson = options.value.data;
    var coordinates = (geojson === null || geojson === void 0 || (_geojson$geometry = geojson.geometry) === null || _geojson$geometry === void 0 ? void 0 : _geojson$geometry.coordinates) || geojson;
    var res = {
      name_line: options.value.name,
      coordinates_line: coordinates,
      id_line: options.value.id
    };
    var newResponse = _objectSpread(_objectSpread({}, getCurrentResponseValue()), res);
    setResponses(newResponse);
    onChange(responseValue, newResponse, null, index);
  };
  var handleChange = function handleChange(suffix, optionsToValue, options) {
    var _geojson$geometry2;
    var geojson = options.value.data;
    var coordinates = (geojson === null || geojson === void 0 || (_geojson$geometry2 = geojson.geometry) === null || _geojson$geometry2 === void 0 ? void 0 : _geojson$geometry2.coordinates) || geojson;
    var res = _defineProperty(_defineProperty(_defineProperty({}, "name_".concat(suffix), options.value.name), "coordinates_".concat(suffix), coordinates), "id_".concat(suffix), options.value.id);
    var newResponse = _objectSpread(_objectSpread({}, getCurrentResponseValue()), res);
    setResponses(newResponse);
    onChange(newResponse, newResponse, null, index);
  };
  var init = function init() {
    var responsesFromHistoric = Collector.getCurrentOrderResponses(currentOrder, responses);
    var currentResponses = responsesFromHistoric === null || responsesFromHistoric === void 0 ? void 0 : responsesFromHistoric.responses;
    setResponses(currentResponses);
  };

  /**
   * Initialization
   */
  useEffect(function () {
    init();
  }, []);
  var getValue = function getValue(suffix) {
    var _geojson$geometry3;
    var alias = currentQuestion.alias;
    if (!responseValue) {
      return null;
    }
    var geojson = responseValue["".concat(alias, "_coordinates_").concat(suffix)] || null;
    var coordinate = (geojson === null || geojson === void 0 || (_geojson$geometry3 = geojson.geometry) === null || _geojson$geometry3 === void 0 ? void 0 : _geojson$geometry3.coordinates) || geojson;
    return {
      data: coordinate,
      id: responseValue["".concat(alias, "_id_").concat(suffix)],
      alias: responseValue["".concat(alias, "_name_").concat(suffix)][locale],
      name: responseValue["".concat(alias, "_name_").concat(suffix)]
    };
  };
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "5",
    className: "mb-3 pb-1 border-bottom d-flex justify-content-start "
  }, _translate('collectorapp_line')), /*#__PURE__*/React.createElement(Col, {
    sm: "5",
    className: "mb-3 pb-1 border-bottom d-flex justify-content-start "
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    alias: currentQuestion.alias,
    urlResource: "/autocomplete/lines/".concat(currentQuestion.id),
    name: "name",
    resource: "GeometryPoint",
    min_character_search: min_character_search,
    filters: {
      'excludedFields=[0]': 'data'
    },
    tag: "name",
    display: "name",
    onChange: handleChangeLine,
    value: getValue('line')
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "5",
    className: "mb-3 pb-1 border-bottom d-flex justify-content-start "
  }, _translate('collectorapp_stop_start')), /*#__PURE__*/React.createElement(Col, {
    sm: "5",
    className: "mb-3 pb-1 border-bottom d-flex justify-content-start "
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    alias: currentQuestion.alias,
    urlResource: "/autocomplete/points/".concat(currentQuestion.id),
    name: "name",
    resource: "GeometryPoint",
    min_character_search: min_character_search,
    filters: {
      line: line,
      'excludedFields=[0]': 'data'
    },
    disabled: line ? false : true,
    tag: "name",
    display: "name",
    onChange: function onChange() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return handleChange.apply(void 0, ['start'].concat(args));
    },
    value: getValue('start')
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "5",
    className: "mb-3 pb-1 border-bottom d-flex justify-content-start "
  }, _translate('collectorapp_stop_end')), /*#__PURE__*/React.createElement(Col, {
    sm: "5",
    className: "mb-3 pb-1 border-bottom d-flex justify-content-start "
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    alias: currentQuestion.alias,
    urlResource: "/autocomplete/points/".concat(currentQuestion.id),
    name: "name",
    resource: "GeometryPoint",
    min_character_search: min_character_search,
    filters: {
      line: line
    },
    disabled: line ? false : true,
    tag: "name",
    display: "name",
    clearable: true,
    onChange: function onChange() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return handleChange.apply(void 0, ['end'].concat(args));
    },
    value: getValue('end')
  })));
};
SelectionListLineStops.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({}))
};
SelectionListLineStops.defaultProps = {
  elements: [],
  responses: {}
};
export default SelectionListLineStops;